import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/highlights/page/[pageNumber]/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightCard"] */ "/app/src/components/HighlightCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighlightHero"] */ "/app/src/heros/HighlightHero/index.tsx");
